// Copyright (c) 2026 Dyna Robotics, Inc. All rights reserved.
// Dyna Robotics Proprietary and Confidential.
// Unauthorized copying, use, or distribution is prohibited.
// SPDX-License-Identifier: LicenseRef-Dyna-Internal

import type { ReactNode } from "react";

/**
 * The label of a button that adds something: "+ 新建", "+ Add Device".
 *
 * The plus is markup, not part of the translation, because the same words also title the
 * dialog the button opens and label its submit, where a plus would be wrong. It is hidden
 * from assistive technology, so the button is still announced by its words alone.
 *
 * It is drawn, not typed. A "+" character sits wherever the font puts it — PingFang on a
 * Mac, Noto elsewhere — and in more than one of them that is visibly below the middle of
 * the words. A cross centred in its own box, in a row centred on the label, lands on the
 * label's middle whatever the font.
 */
export function AddLabel({ children }: { children: ReactNode }) {
  return (
    <span className="add-label">
      <svg className="add-plus" viewBox="0 0 12 12" aria-hidden="true" focusable="false">
        <path d="M6 1.5v9M1.5 6h9" />
      </svg>
      {children}
    </span>
  );
}
